import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcMicrophoneOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="m23.01 15.859 1.98.282c-.688 4.816-3.425 7.49-7.99 7.823V28h7v2H8v-2h7l-.001-4.036c-4.467-.326-7.183-2.894-7.942-7.516l-.047-.307 1.98-.282C9.587 20.034 11.833 22 16 22c4.072 0 6.31-1.877 6.967-5.86l.043-.281ZM16 2a5 5 0 0 1 5 5v8a5 5 0 0 1-10 0V7a5 5 0 0 1 5-5Zm0 2a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V7a3 3 0 0 0-3-3Z"
        fill="currentColor"
      />
      <path
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="square"
        d="m2 2 28 28"
      />
    </g>
  </svg>
);
export default SvgIcMicrophoneOff;
